import SnippetLink from '../Shared/Link/Link'
import { Props_SnippetButton } from './Button.props'

const SnippetButton = (props: Props_SnippetButton) => {
    const { button } = props
    return (
        <SnippetLink
            linkStyles={button.linkStyle?.value}
            className="snippet-button"
            url={button.linkHref?.value}
            openInNewTab={button.linkTarget?.value}
        >
            {button.linkText?.value}
        </SnippetLink>
    )
}

export default SnippetButton